import $ from 'jquery';

require("selectize");
require("./latinise");

import FileDownloader from './filedownloader';
import Echo from "laravel-echo";

class Search {

	constructor() {


		Vue.component('product',  () => import('../components/Product.vue'));
		Vue.component('results',  () => import('../components/SearchResults.vue'));

		Vue.component('asset',  () => import('../components/Asset.vue'));
		Vue.component('asset-results',  () => import('../components/AssetSearchResults.vue'));

        $("#pdf-loading").hide();
		$("#download-pdf").click(e => {
			if (!window.Echo) {
				window.Echo = new Echo({
					broadcaster: 'pusher',
					key: '372be142e45c91750700',
					cluster: 'eu', // 'mt1',// 'us2',
					forceTLS: true
				});
			}
			$("#download-group").hide();
			$("#pdf-loading").show();
			e.preventDefault();
			$.ajax({
				url: $(e.target).data("url"),
				method: 'GET',
				success: (d, s) => {
					console.log(d);
					if (d.job_id) {

						$("#pdf-loading .prog").width(0).html("");
                        window.Echo.private(`file.${d.job_id}`).listen('.download', ev => {
                            console.log("event: ", ev);
                            new FileDownloader(ev.file, ev.filename, ev.contenType);
                            $("#download-group").show();
                            $("#pdf-loading").hide();
                        })

                        window.Echo.private(`progress.${d.job_id}`).listen('.update', ev => {
                            console.log("progress", ev.progress);
                            if (ev.progress > 0) {
                                $("#pdf-loading .progress-bar").removeClass("progress-bar-striped");
                                $("#pdf-loading .progress-bar").removeClass("active");
							}
                            $("#pdf-loading .prog").width((ev.progress * 80) + "%").html((ev.progress * 100).toFixed(1) + "%");
                            if (ev.progress === 1) {
                                $("#pdf-loading .progress-bar").html("");
                                $("#pdf-loading .prog").html("Receiving file, please wait");
                                $("#download-pdf").click();
							}
                        })
					} else {
                        new FileDownloader(d.file, d.filename, d.contenType);
                        $("#download-group").show();
                        $("#pdf-loading").hide();
					}
				}
			})
		})

		if ($("#search_form").length == 0) {
			return;
		}

		this.brandnames = [];
		this.companynames = [];

		$(".selectize").selectize({
			plugins: ['remove_button']

		});

		$(".search_multiselect").attr("disabled", "disabled");
		this.loadData(() => {
			$(".search_multiselect").attr("disabled", false);
			$('.search_multiselect').each((i, selector) => {
				$(selector).removeClass("form-control");
				let key = $(selector).data("key");
				let items = this[key];
				let options = {
			        plugins: ['remove_button'],
			        valueField: 'display',
			        labelField: 'display',
			        create: false,
			        openOnFocus: false,
			        render: {
			            option: (item, escape) => {
			                return '<div>' + escape(item.display) + "</div>";
			            }
			        },
			        score: (query) => {
			        	let q = query.toLowerCase().latinise().replace(/\W/g, '');
			        	return (element) => {
			        		return element.key.indexOf(q) !== -1 ? 1: 0;
			        	};
			        },
			        load: (query, callback) => {
			        	if (!query.length) return callback();

			            let res = this.search(items, query.toLowerCase().latinise().replace(/\W/g, ''));
			            //console.log(res);

			            callback(res);

			        }
			    };

				$(selector).selectize(options);
			});



		});


	}

	search(list, query) {
		console.log(query);
		return $.grep(list, element => {
			let t = element.key.indexOf(query) !== -1;
			return t;
		});
	}


	loadData(callback) {

		$.ajax({data:{op:"preloadSearchData"},
			success: (d, s) => {

				if (d.brandnames) {
					this.brandnames = this.preprocess(d.brandnames);
				}
				if (d.companynames) {
					this.companynames = this.preprocess(d.companynames);
				}

				callback();

			}

		})

	}

	preprocess(entries) {
		return $(entries).map((index, element) => {
			return {
				key: element.toLowerCase().latinise().replace(/\W/g, ''),
				display: element
			};
		});

	}


}

export default Search;
